import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'miq-compare-common-fields',
  templateUrl: './compare-common-fields.component.html',
  styleUrls: ['./compare-common-fields.component.scss'],
  standalone: false,
})
export class CompareCommonFieldsComponent {
  @Input() headerColumns: any;
  @Input() rowData: any;
  @Output() rdChange = new EventEmitter();
}
